<script setup>
  import { ref, computed, watchEffect } from 'vue';

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    drawingManager: {
      type: Object,
      required: true
    },
    points: {
      type: Array,
      required: true
    },
    shapeClosed: {
      type: Boolean,
      default: false
    },
    fill: {
      type: String,
      default: '#FF0000'
    },
    fillOpacity: {
      type: Number,
      default: 1
    },    
    strokeColor: {
      type: String,
      default: '#FF0000'
    },
    strokeOpacity: {
      type: Number,
      default: 1.0
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  });

  const strokeColor = ref(props.strokeColor);
  const strokeOpacity = ref(props.strokeOpacity);
  const strokeWidth = ref(props.strokeWidth);

  const points = computed(() => {
    return props.points
      .map((point) => `${point.x},${point.y}`)
      .join(' ')
  });

  const shape = computed(() => {
    return props.shapeClosed ? 'polygon' : 'polyline';
  });

  watchEffect(() => {
    strokeColor.value = props.strokeColor;
    strokeOpacity.value = props.strokeOpacity;
    strokeWidth.value = props.strokeWidth;
  });
</script>

<template>
  <component
    :is="shape" 
    :id="props.id"
    :points="points"
    :fill="props.fill"
    :fill-opacity="`${props.fillOpacity}%`"
    :stroke="props.strokeColor"
    :stroke-width="props.strokeWidth"
    :stroke-opacity="`${props.strokeOpacity}%`"
  />
</template>